import { reducerInitialStateMethods } from '@common/methods/reducerInitialStateMethods';
import { GameType } from '@modules/games/Game/constants/availableGames';

export const kenoInitialState = reducerInitialStateMethods(GameType.KENO);
